"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemRelationsContentFragment = void 0;
exports.itemRelationsContentFragment = `
fragment itemRelationsContent on ItemRelationsContent {
  items {
    id
    name
    path
    components {
      id
      name
      type
      content {
        ...singleLineContent
        ...richTextContent
        ...imageContent
        ...paragraphCollectionContent
        ...propertiesTableContent
        ... on ItemRelationsContent {
          items {
            id
            name
            components {
              id
              name
              type
              content {
                ...singleLineContent
                ...richTextContent
                ...imageContent
                ...paragraphCollectionContent
              }
            }
          }
        }
      }
    }
    ... on Document {
      __typename
      components {
        id
        name
        type
        content {
          ...singleLineContent
          ...richTextContent
          ...imageContent
          ...paragraphCollectionContent
          ... on ItemRelationsContent {
            items {
              id
              name
              components {
                id
                name
                type
                content {
                  ...singleLineContent
                  ...richTextContent
                  ...imageContent
                  ...paragraphCollectionContent
                  ...propertiesTableContent
                  ...booleanContent
                  ... on ItemRelationsContent {
                    items {
                      id
                      name
                      components {
                        id
                        name
                        type
                        content {
                          ...singleLineContent
                          ...richTextContent
                          ...imageContent
                          ...propertiesTableContent
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    ... on Product {
      defaultVariant {
        __typename
        images {
          ...image
        }
      }
    }
  }
}
`;
//# sourceMappingURL=item-relations-content.js.map